import loadScript from "../js/scripts/loadScript";
import loadCSS from "../js/scripts/loadCSS";

export default function (opt) {
    let dns = opt.dns;
    let appVersion = opt.appVersion;
    let mainPhotoGallery;
    let gallerySelector = 'main-photo-gallery-'+opt.newsId;
    $('#main-photo-gallery').attr('id', gallerySelector);
    let gallery = document.getElementById(gallerySelector);

    let reinitMainGallery = $('div[id*="main-photo-gallery-"].photo-gallery:not(.ug-gallery-wrapper)');
    if(reinitMainGallery.length > 0) {

    if (gallery !== null) {
        initAllGalleryDependencies();
    }

    function initAllGalleryDependencies() {

        cleanGalleryContent(gallerySelector);

        let unitegalleryStylesheet = $('#unitegallery-stylesheet');
        if(unitegalleryStylesheet.length === 0) {
            loadCSS(dns + 'assets/tv24/lib/unitegallery/css/main_gallery.min.css?v=' + appVersion);
            let script = loadScript(dns + 'assets/tv24/lib/unitegallery/js/gallery_main.min.js?v=' + appVersion);
            script.onload = function (){
                initGallery(gallery);
            }
        } else {
            initGallery(gallery);
        }
    }

    function cleanGalleryContent(gallerySelector) {
        let gallery = $('#' + gallerySelector);
        gallery.find('noscript').remove();
        gallery.find('script').remove();
    }

    function initGallery(gallery) {
        $(function () {
            mainPhotoGallery = $(gallery).unitegallery({

                /*thumb style begin*/
                thumb_border_effect: false,
                thumb_color_overlay_effect: true,
                thumb_overlay_color: "#ffffff",
                thumb_overlay_reverse: false,
                thumb_overlay_opacity: 0.4,
                /*thumb style end*/
                theme_hide_panel_under_width: 480,          //hide panel under certain browser width, if null, don't hide

                slider_scale_mode: "fit",                  //scale mode for main image in gallery
                slider_scale_mode_fullscreen: "full",       //fit, down, full scale mode on fullscreen.
                slider_loader_type: 7,                      //shape of the loader (1-7)
                slider_controls_always_on: true,           //hide controls
                slider_progress_indicator_type: "bar",     //progress bar type
                slider_progressbar_color: "#333"             //progress bar color
            });

            $(".main-photo-gallery-wrapper .ug-top-right-wraper .ug-default-button-play").click(function () {
                $(this).toggleClass("ug-stop-mode");
                mainPhotoGallery.togglePlay();
            });

            $(".main-photo-gallery-wrapper .ug-top-right-wraper .ug-default-button-fullscreen").click(function () {
                mainPhotoGallery.toggleFullscreen();
            });

            // Fix showing thumbnails
            mainPhotoGallery.resize(gallery.offsetWidth - 1);
        });
    }
    }
}